<form [formGroup]="form">
  <fieldset>
    <legend>
      <div>
        <span i18n>Search & Replace</span>
      </div>
    </legend>
    <div class="form-container">
      <mat-form-field appearance="outline" class="form-search">
        <mat-label i18n>Search</mat-label>
        <input matInput type="text" formControlName="search" required>
      </mat-form-field>
      <mat-form-field appearance="outline" class="form-replace">
        <mat-label i18n>Replace</mat-label>
        <input matInput type="text" formControlName="replace">
      </mat-form-field>
      <div  class="form-button text-center">
        <button type="button" mat-flat-button color="primary" [disabled]="form.invalid" (click)="onSubmit()" i18n>
          Replace
        </button>
      </div>
    </div>
    @if (form.pristine && namesReplaced !== undefined) {
      <p i18n>
      {{ namesReplaced }} occurrence(s) of "{{ lastSearch.search }}" replaced by "{{ lastSearch.replace }}".
    </p>
    }
  </fieldset>
</form>
